import AppLoader from 'components/AppLoader';
import { UserItem } from 'components/UserManagement/UserItem';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import useStores from 'stores/helpers/useStores';
import styled from 'styled-components';

const ListWrapper = styled.div`
  padding-bottom: 24px;
`;

const UserList: React.FC = () => {
  const { playerStore } = useStores();

  useEffect(() => {
    if (!playerStore.players.length) {
      playerStore.loadPlayers();
    }
  }, []);

  if (playerStore.loading) {
    return <AppLoader />;
  }

  return (
    <ListWrapper>
      {playerStore.players.map((player) => (
        <UserItem key={player.id} user={player} />
      ))}
    </ListWrapper>
  );
};

export default observer(UserList);
